<section class="main">
    <h3>Create new category</h3>


    <label>Select type</label>
    <div class="dropdown mb-0 ">
        <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{typename}}
            <img src="assets/images/mangeunit/arrow.png">
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
            <li *ngFor="let item of typearr">
                <a class="dropdown-item" (click)="gettypeInfo(item)">
                  {{item.name}}
                </a>
            </li>
        </ul>
    </div>
    <!-- <span *ngIf="statusProject" class="erorrMasge">Project is required</span>   -->

    <form>
        <div class="row mt-3">
            <div class="col">
                <div class="form-group">
                    <label>Category name</label>
                    <input required name="name"  [ngClass]="{ 'is-invalid': submitted && categroyName == '' }"
                     [(ngModel)]="categroyName" placeholder="EX. Home" type="text" class="form-control">
                </div>
            </div>
        </div>

        <div class="addUnits d-flex justify-content-end mt-5 mb-2">
            <div>
                <button mat-dialog-close class="btn me-2">Cancel</button>
                <button (click)="submit()" class="btn addUnit">Add category</button>
            </div>
        </div>
    </form>
</section>